export const guideUrl =
  'https://cdn.prod.website-files.com/6044f1e731fd086115d71bf9/682ed62b9bc221926e164251_21c75744d1601fefa580455578726f5f_Gui%CC%81a%20Payflow%20-%20Personio%20%282025%29.pdf';
